import { optionalAllowed } from "@/lib/consent";

const KEY = "lexv_activity";
let mem = null;
const read = () => { if (!optionalAllowed() && mem) return mem; try { return { goal: 20, days: {}, ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return { goal: 20, days: {} }; } };
const write = (a) => { if (!optionalAllowed()) { mem = a; return; } localStorage.setItem(KEY, JSON.stringify(a)); };
export const dayKey = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const hasAnswer = (r = {}) => [r.text, r.summary, r.opinion].some((v) => v && v.trim());
const shift = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d; };

export const recordActivity = (n = 1) => {
  const a = read(); const k = dayKey();
  a.days[k] = (a.days[k] || 0) + n;
  a.met = a.met || {};
  if (a.days[k] >= a.goal) a.met[k] = true;
  write(a);
};
export const setGoal = (goal) => { const a = read(); a.goal = goal; a.met = a.met || {}; if ((a.days[dayKey()] || 0) >= goal) a.met[dayKey()] = true; write(a); };

export const getStreak = () => {
  const a = read();
  const metKey = (k) => !!a.met?.[k] || (k === dayKey() && (a.days[k] || 0) >= a.goal);
  const met = (i) => metKey(dayKey(shift(i)));
  let streak = 0;
  for (let i = met(0) ? 0 : 1; met(i); i++) streak++;
  let best = 0, run = 0;
  Object.keys(a.days).sort().forEach((k, i, arr) => {
    if (!metKey(k)) { run = 0; return; }
    const prev = i && new Date(arr[i - 1]);
    const contiguous = prev && (new Date(k) - prev) / 86400000 === 1 && metKey(arr[i - 1]);
    run = contiguous ? run + 1 : 1;
    best = Math.max(best, run);
  });
  const week = [6, 5, 4, 3, 2, 1, 0].map((i) => { const d = shift(i); return { key: dayKey(d), label: d.toLocaleDateString(undefined, { weekday: "narrow" }), count: a.days[dayKey(d)] || 0, met: metKey(dayKey(d)) }; });
  return { goal: a.goal, today: a.days[dayKey()] || 0, streak, best: Math.max(best, streak), week };
};
